import PropType from 'prop-types';

function DateTimeRenderer({options, value}) {
    if (!value) {
        return null;
    }

    const locale = Liferay.ThemeDisplay.getLanguageId().replaceAll('_', '-');
    const dateOptions = options?.format || {
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        month: 'short',
        second: 'numeric',
        year: 'numeric',
    };
    const formattedDate = new Intl.DateTimeFormat(locale, dateOptions).format(
        new Date(value)
    );

    return formattedDate;
}

DateTimeRenderer.propTypes = {
    options: PropType.shape({
        format: PropType.object,
    }),
    value: PropType.string.isRequired,
};

export default DateTimeRenderer;